import React from "react";

const FAQ = () => (
  <div style={{ 
    minHeight: "60vh", 
    display: "flex", 
    flexDirection: "column", 
    alignItems: "center", 
    justifyContent: "center", 
    background: "linear-gradient(135deg, #4FA0FF 0%, #1D3557 100%)" 
  }}>
    <div style={{ fontSize: 64, marginBottom: 16, color: "#FFD700" }}>🚧</div>
    <h1 style={{ color: "#fff", fontWeight: 700, fontSize: "2.2rem", marginBottom: 12 }}>Coming Soon</h1>
    <p style={{ color: "#e0e0e0", fontSize: "1.15rem" }}>This page will be available soon.</p>
  </div>
);

export default FAQ;